export const getScannerWebappOrigin = () => {
  if (window.location.hostname === "localhost" && window.location.port === "3000") {
    return `${window.location.protocol}//${window.location.hostname}:3002`;
  }

  return window.location.origin;
};

export const buildAuditCodeAccessUrl = (code: string) =>
  `${getScannerWebappOrigin()}/scan/?code=${code}`;

